import { render, staticRenderFns } from "./hitchRideOrderDispatchMap.vue?vue&type=template&id=54f663d5"
import script from "./hitchRideOrderDispatchMap.vue?vue&type=script&lang=js"
export * from "./hitchRideOrderDispatchMap.vue?vue&type=script&lang=js"
import style0 from "./hitchRideOrderDispatchMap.vue?vue&type=style&index=0&id=54f663d5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports